import { useEffect, useState } from 'react';
import { getMasterEquipmentPartHistoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import { getEquipmentPartHistoriesByQuery } from 'components/axios/equipmentAxios';
import { getTimeString } from 'data/data';

const AvgLifeTime = ({masterEquipmentPartId, position, useLife=null}) => {

    const [avgLifeTime, setAvgLifeTime] = useState();
    const [overLifeColor, setOverLifeColor] = useState('#000');

    useEffect(()=>{
        if (masterEquipmentPartId) {
            if (position) {
                getEquipmentPartHistoriesByQuery({masterEquipmentPartId, position}).then((data)=>{
                    if (data && data._embedded && data._embedded.equipmentPartHistories) {
                        setAvgLifeTime(data._embedded.equipmentPartHistories[0].avgLifeTime);
                        return data._embedded.equipmentPartHistories[0].avgLifeTime;
                    } else {
                        setAvgLifeTime(0);
                        return 0;
                    }
                }).then((res)=>{
                    if (useLife) {
                        if (useLife > res) {
                            setOverLifeColor('red')
                        } else {
                            setOverLifeColor('#000')
                        }
                    }
                })
            } else {
                getMasterEquipmentPartHistoriesByQuery({masterEquipmentPartId}).then((data)=>{
                    if (data && data._embedded && data._embedded.masterEquipmentPartHistories) {
                        setAvgLifeTime(data._embedded.masterEquipmentPartHistories[0].avgLifeTime);
                        return data._embedded.masterEquipmentPartHistories[0].avgLifeTime;
                    } else {
                        setAvgLifeTime(0);
                        return 0;
                    }
                }).then((res)=>{
                    if (useLife) {
                        if (useLife > res) {
                            setOverLifeColor('red')
                        } else {
                            setOverLifeColor('#000')
                        }
                    }
                })
            }
        }
    },[masterEquipmentPartId, position]);

    return (
        <span style={{color:`${overLifeColor}`}}>{getTimeString(avgLifeTime)}</span>
    )
}

export default AvgLifeTime;